import { render, staticRenderFns } from "./LinkBadge.vue?vue&type=template&id=858decb0&"
import script from "./LinkBadge.vue?vue&type=script&lang=js&"
export * from "./LinkBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports